import { GET_CURRENT_HOST, GET_CURRENT_VISITOR } from 'graphql/queries';
import { mockedGetCurrentVisitorNonAdminDataForQuery } from '../graphqlApollo/query/getCurrentVisitor';

export const queries = [
  {
    request: {
      query: GET_CURRENT_HOST
    },
    newData: () => ({
      data: mockedGetCurrentVisitorNonAdminDataForQuery
    })
  },
  {
    request: {
      query: GET_CURRENT_VISITOR
    },
    newData: () => ({
      data: mockedGetCurrentVisitorNonAdminDataForQuery
    })
  }
];
